<template>
  <div
    :class="`${isInvalidInput && 'isInvalidInput'}`"
    :style="`width: 100%; ${
      filterIsEnable && enableIconCreate
        ? 'padding-right: 39px !important'
        : 'padding-right: 20px !important'
    } ${noPadding ? 'padding-right: 0 !important' : ''} `"
  >
    <div style="position: relative">
      <div
        :style="`${
          filterIsEnable
            ? 'border-radius: 0'
            : 'border-radius:0 0.25rem 0.25rem 0'
        }`"
        :class="`iconSelectInfinit ${isDisabled && 'iconDisabledInfinit'}`"
        v-if="enableIconCreate"
        @click="createModal"
      >
        <div role="button">
          <b-icon-plus scale="2"></b-icon-plus>
        </div>
      </div>

      <div
        :class="`iconFilterSelectInfinit ${
          isDisabled && 'iconDisabledInfinit'
        }`"
        :style="!enableIconCreate && 'right: -18px !important;'"
        v-if="filterIsEnable"
        @click="toggleFilter"
        ref="boxClick"
      >
        <div role="button">
          <b-icon-filter scale="1.3"></b-icon-filter>
        </div>
      </div>

      <div
        class="boxFilter"
        ref="box"
        :style="!filterIsOpen && 'display: none'"
      >
        <div class="containerRadio">
          <label>
            <input
              type="radio"
              :name="`radio-${this.typeFilter}`"
              v-model="filterType"
              value="includes"
            />
            <span style="border-radius: 5px 0 0 5px">Contém</span>
          </label>

          <label>
            <input
              type="radio"
              :name="`radio-${this.typeFilter}`"
              v-model="filterType"
              value="start"
            />
            <span style="border-radius: 0 5px 5px 0">Iniciar por</span>
          </label>
        </div>
      </div>

      <label
        v-if="showLabel && defaultLabel"
        :class="`floatLabel ${isInvalidInput && 'invalidLabel'}`"
      >
        {{ label }}
      </label>
      <label
        v-else-if="showLabel && !defaultLabel"
        :class="`defaultLabel ${isInvalidInput && 'invalidLabel'}`"
      >
        {{ label }}:
      </label>

      <v-select
        :disabled="isDisabled"
        :value="selected"
        :label="text"
        :options="dataList"
        :filterable="false"
        :loading="loading ? true : false"
        :custom-filter="customFilter"
        @input="setSelected"
        @open="onOpen"
        @close="onClose"
        @search="searchByWriting"
      >
        <template v-slot:option="slotProps">
          <div class="custom-option custom-option--large">
            <div class="custom-option__info">
              <div class="option-style-title">
                <strong class="custom-option__title">{{
                  slotProps[typeSlotProps.fistValue]
                }}</strong>
                <span>
                  {{ slotProps[typeSlotProps.secondValue] || "--" }}
                </span>
              </div>
            </div>
          </div>
        </template>
        <template #list-footer>
          <li v-show="hasNextPage" ref="load" class="loader">
            Loading more options...
          </li>
        </template>

        <template #no-options>
          <div>Resultado não encontrado!</div>
        </template>

        <template #spinner="{ loading }">
          <div
            v-if="loading"
            style="border-left-color: rgba(88, 151, 251, 0.71)"
            class="vs__spinner"
          ></div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import { debounce } from "../../../utils/debounce";
export default {
  name: "InfiniteScroll",
  props: {
    dataInput: {
      type: [String, Number],
      default: "",
    },
    isEdit: {
      type: [String, Number, Boolean],
    },
    text: {
      type: String,
      default: "nome",
    },
    value: {
      type: String,
      default: "id",
    },
    onSearch: {
      type: Function,
    },
    label: {
      type: String,
      default: "label",
    },
    enableIconCreate: {
      type: Boolean,
      default: true,
    },
    openCreateModal: {
      type: Function,
    },
    isInvalidInput: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
    },
    findAll: {
      type: Boolean,
      default: false,
    },
    defaultLabel: {
      type: Boolean,
      default: true,
    },
    clearSelected: {
      type: Boolean,
      default: false,
    },
    searchFields: {
      typeof: Array,
    },
    filterIsEnable: {
      type: Boolean,
      default: true,
    },
    typeFilter: {
      type: String,
      default: "default",
    },
    typeSlotProps: {
      type: Object,
      default: () => ({
        fistValue: "nome",
        secondValue: "registro",
      }),
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    dropdownBoundary: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      observer: null,
      dataList: [],
      selected: null,
      loading: false,
      filterIsOpen: false,
      filterType: "includes",
      page: 1,
      pageSize: 20,
      hasNextPage: false,
      searchQuery: "",
      debouncedSearch: null,
      scrollPosition: 0,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.removeClearButtonTitle();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateDropdownMaxHeight);
    document.removeEventListener("scroll", this.updateDropdownMaxHeight, true);
    if (this.observer) this.observer.disconnect();
    if (
      this.debouncedSearch &&
      typeof this.debouncedSearch.cancel === "function"
    ) {
      this.debouncedSearch.cancel();
    }
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
    this.debouncedSearch = debounce((search) => {
      if (this.loading) return;
      this.searchQuery = search;
      this.search(false);
    }, 350);
    this.findInitial();
  },
  methods: {
    observeLoader() {
      if (this.hasNextPage) {
        this.$nextTick(() => {
          const loader = this.$refs.load;
          if (loader) {
            this.observer.observe(loader);
          }
        });
      }
    },
    async search(loadingMore = false) {
      if (this.loading) return;
      this.loading = true;

      if (this.$refs.load) {
        this.observer.unobserve(this.$refs.load);
      }

      if (!loadingMore) {
        this.page = 1;
        this.dataList = [];
        this.hasNextPage = false;
      }

      try {
        const newProducts = await this.onSearch(
          this.isEdit ? this.dataInput : "",
          this.searchQuery,
          this.filterType,
          this.page
        );

        if (this.dataInput) {
          this.selected = newProducts.find(
            (item) => String(item[this.value]) === String(this.dataInput)
          );

          this.$emit("selectItem", this.selected);
        }

        if (newProducts && newProducts.length > 0) {
          if (loadingMore) {
            const existingIds = new Set(this.dataList.map((p) => p.id));
            const uniqueNewProducts = newProducts.filter(
              (p) => !existingIds.has(p.id)
            );
            this.dataList.push(...uniqueNewProducts);

            this.$nextTick(() => {
              const menu = this.$el.querySelector(".vs__dropdown-menu");
              if (menu) {
                menu.scrollTop = this.scrollPosition;
              }
            });
          } else {
            this.dataList = newProducts;
          }
          this.hasNextPage = newProducts.length === this.pageSize;
          this.page += 1;
        } else {
          if (loadingMore) this.hasNextPage = false;
        }

        this.observeLoader();
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
        this.hasNextPage = false;
      } finally {
        this.loading = false;
      }
    },

    async findInitial() {
      await this.search(false);
    },

    async findToEdit() {
      await this.findInitial();
    },

    searchByWriting(search) {
      this.debouncedSearch(search);
    },

    async infiniteScroll([{ isIntersecting }]) {
      if (isIntersecting && this.hasNextPage && !this.loading) {
        const menu = this.$el.querySelector(".vs__dropdown-menu");
        if (menu) {
          this.scrollPosition = menu.scrollTop;
        }
        await this.search(true);
      }
    },

    updateDropdownMaxHeight() {
      if (!this.dropdownBoundary) return;

      const menu = this.$el.querySelector(".vs__dropdown-menu");
      if (!menu) return;

      const boundary = document.querySelector(this.dropdownBoundary);
      const boundaryTop = boundary ? boundary.getBoundingClientRect().top : window.innerHeight;
      const scrollContainer = this.$el.closest(".ModalGeneral");
      const containerRect = scrollContainer && scrollContainer.getBoundingClientRect();
      const bottom = Math.min(
        window.innerHeight,
        boundaryTop,
        containerRect ? containerRect.bottom : window.innerHeight
      );
      const select = this.$el.querySelector(".v-select");
      if (!select) return;

      const rect = select.getBoundingClientRect();
      const spaceBelow = bottom - rect.bottom - 8;
      const spaceAbove = rect.top - Math.max(0, containerRect ? containerRect.top : 0) - 8;
      const openAbove = spaceBelow < 160 && spaceAbove > spaceBelow;

      menu.style.top = openAbove ? "auto" : "100%";
      menu.style.bottom = openAbove ? "100%" : "auto";
      menu.style.maxHeight = `${Math.max(0, Math.min(350, openAbove ? spaceAbove : spaceBelow))}px`;
      menu.style.overflowY = "auto";
    },

    async onOpen() {
      await this.$nextTick();
      this.updateDropdownMaxHeight();
      if (this.dropdownBoundary) {
        window.addEventListener("resize", this.updateDropdownMaxHeight);
        document.addEventListener("scroll", this.updateDropdownMaxHeight, true);
      }
      this.observeLoader();
    },

    setSelected(itemSelect) {
      this.selected = itemSelect;

      if (itemSelect) {
        this.$emit("update:dataInput", itemSelect[this.value]);
        this.$emit("selectItem", itemSelect);
        this.clearInvalidInput();
      } else {
        this.$emit("update:dataInput", "");
        this.$emit("selectItem", "");
        this.clearInvalidInput();
      }
    },

    onClose() {
      window.removeEventListener("resize", this.updateDropdownMaxHeight);
      document.removeEventListener("scroll", this.updateDropdownMaxHeight, true);
      this.$emit("closed");
      this.observer.disconnect();
    },

    removeClearButtonTitle() {
      this.$nextTick(() => {
        const clearButton = document.querySelector(".vs__clear");
        if (clearButton) {
          clearButton.title = "Remover seleção";
        }
      });
    },

    createModal() {
      if (this.openCreateModal) return this.openCreateModal();

      return;
    },
    customFilter(option, label, search) {
      const searchLower = search.toLowerCase();

      if (this.searchFields && this.searchFields.length) {
        return this.searchFields.some((field) =>
          String(option[field]).toLowerCase().includes(searchLower)
        );
      }

      return option[this.text].toLowerCase().includes(searchLower);
    },
    toggleFilter() {
      this.filterIsOpen = !this.filterIsOpen;
    },

    handleClickOutside(event) {
      const box = this.$refs.box;
      const boxClick = this.$refs.boxClick;

      if (
        box &&
        !box.contains(event.target) &&
        boxClick &&
        !boxClick.contains(event.target)
      ) {
        this.filterIsOpen = false;
      }
    },

    clearInvalidInput() {
      this.$emit("clearInvalidInput");
    },
  },
  watch: {
    clearSelected() {
      this.selected = "";
    },
    isEdit() {
      this.findToEdit();
    },
    findAll() {
      this.findInitial();
    },
  },
};
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
  height: 30px !important;
}

.custom-option {
  font-size: 16px;
  line-height: 1.4;
  padding: 0px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 2px;
}

.selected-option {
  font-size: 16px;
  font-weight: bold;
}
.custom-option--large {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
}

.custom-option__img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 3px;
}

.custom-option__info {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 1.2;
  gap: 2px;
  width: 100%;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

li {
  padding: 0px !important;
}

.option-style-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
}

.option-style-title span {
  display: inline-block;
  max-width: 48%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-option__title {
  font-size: 12px;
  margin: 0;
  text-overflow: ellipsis;
  white-space: break-spaces;
  width: 90%;
}

.custom-option--selected {
  display: flex;
  align-items: center;
  height: 80px;
}

.custom-option__img--small {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 3px;
  margin-right: 6px;
}

.custom-option__title--small {
  font-size: 13px;
}
.boxFilter {
  display: flex;
  height: 30px;
  justify-content: space-between;
  background-color: white;
  position: absolute;
  top: 33px;
  right: -40px;
  z-index: 500;
  border-radius: 5px;
  box-shadow: 0 0 3px 0 #0000006b;
}

.boxFilter::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 3px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid white;
  z-index: -99999;
}

.vs__dropdown-toggle {
  height: 30px;
}

.vs__search {
  font-size: 16px !important;
  color: #495057 !important;
}

.vs__selected {
  font-size: 16px !important;
}

.vs__dropdown-toggle {
  width: 100%;
  white-space: normal !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding: 0 0 4px;
}

.vs1__listbox {
  width: 100%;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.vs__dropdown-option--highlight {
  white-space: normal !important;
  word-break: break-all !important;
  padding: 0 5px !important;
}

.vs__dropdown-option {
  padding: 0px !important;
}

.vs__dropdown-menu {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-width: 100% !important;
  width: 100% !important;
  box-sizing: border-box;
  text-overflow: ellipsis !important;
  white-space: normal;
  padding: 5px !important;
  font-size: 16px;
}

.floatLabel {
  position: absolute;
  left: 3px;
  font-size: 8.5px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  top: -9px;
  left: 7px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  background-color: #ffff;
  padding: 0 0.2em;
  z-index: 999;
}

.defaultLabel {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  bottom: 30px;
  left: 0px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: transparent;
  font-weight: 600;
}

.iconSelectInfinit {
  position: absolute;
  right: -18px !important;
  top: 0 !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: whitesmoke;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0 0.25rem 0.25rem 0;
}

.iconDisabledInfinit {
  pointer-events: none !important;
}

.iconFilterSelectInfinit {
  position: absolute;
  right: -38px !important;
  top: 0 !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: whitesmoke;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0 0.25rem 0.25rem 0;
  border-left: solid 1px rgba(129, 129, 129, 0.26);
}

.iconDisabledInfinit {
  pointer-events: none !important;
}

.containerRadio {
  display: flex;
}

.containerRadio label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0;
}

.containerRadio label input {
  position: absolute;
  left: -9999px;
}

.containerRadio label input:checked + span {
  background-color: #f3f2f2;
  color: rgb(0, 0, 0);
}

.containerRadio label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #006256;
}

.containerRadio label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 2px;
  transition: 0.25s ease;
  font-size: 11px;
}

.containerRadio label span:hover {
  background-color: #e6e6e6;
}

.containerRadio label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #006256;
}

.isInvalidInput {
  transition: ease-in all 0.1s !important;
  box-shadow: 0 0 0 1.5px rgba(204, 21, 21, 0.583) !important;
  border-radius: 0.25rem !important;
}

.invalidLabel {
  color: rgba(142, 15, 15, 0.583);
}
@media (max-width: 768px) {
  .floatLabel {
    position: absolute;
    left: 3px;
    font-size: 11px !important;
    font-family: Poppins-Regular, sans-serif !important;
    font-weight: 600;
    top: -10px;
    left: 7px;
    pointer-events: none;
    white-space: nowrap !important;
    text-overflow: ellipsis;
    color: #666360;
    height: 12px;
    background-color: #ffff;
    padding: 0 0.2em;
    z-index: 999;
  }
}
</style>
